module.exports = __webpack_public_path__ + "static/5-1620c05232348e1f585f698ab6b06236.gif";